var _path, _rect, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationServices = function SvgNotificationServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 126,
    fill: "none",
    viewBox: "0 0 129 126"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAD6CD",
    d: "M122.019 13.652v100.525c0 4.427-3.745 8.02-8.36 8.02h-74.58a8.6 8.6 0 0 1-2.106-.262c-3.6-.898-6.253-4.026-6.253-7.758V13.652c0-4.432 3.745-8.02 8.36-8.02h74.579c4.615 0 8.36 3.588 8.36 8.02"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 83,
    height: 59,
    x: 9,
    y: 25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81.92,
    height: 57.45,
    x: 9.216,
    y: 25.6,
    fill: "#D9D9D9",
    rx: 14
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7886D9",
    d: "M9.216 24.005v59.11h82.18v-59.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E398E",
    d: "m50.953 49.006 40.449 34.045-82.186-.155 41.729-33.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M50.708 24.004H9.216v59.047h41.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M50.708 49.006q-.015 0 0 0l-.173 34.045H9.216l41.483-34.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M50.192 65.548 90.87 25.6H9.216l40.968 39.948z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EADFD",
    d: "M50.192 65.548V25.6H9.216l40.968 39.948z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M90.21 112.71c11.931 0 21.603-9.529 21.603-21.283s-9.672-21.283-21.603-21.283c-11.93 0-21.602 9.529-21.602 21.283S78.28 112.71 90.21 112.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M91.038 70.144h-.068v42.566h.067c11.932 0 21.603-9.528 21.603-21.283s-9.671-21.283-21.603-21.283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M93.149 77.506h-4.511V97.75h4.51zM90.895 106.126c1.37 0 2.48-1.094 2.48-2.444s-1.11-2.445-2.48-2.445-2.481 1.095-2.481 2.445 1.11 2.444 2.48 2.444"
  })));
};
export { SvgNotificationServices as Icon };
export default __webpack_public_path__ + "static/media/73b8c16aa23d473d00b73ab45df0ae74.svg";